import { RoutesList } from './routes-list';

/**
 * Unico elenco delle funzioni in beta: il menu laterale e le intestazioni di
 * pagina leggono da qui il chip "Beta", così non possono divergere.
 */
const BETA_ROUTES: ReadonlySet<string> = new Set<string>([
  RoutesList.LABELS,
  RoutesList.MENUS,
  RoutesList.INGREDIENTS,
  RoutesList.RECALLS,
  RoutesList.TRANSPORT_DOCUMENTS,
  RoutesList.SURVEYS,
  RoutesList.CONSULTANT_DEADLINES,
]);

export function isBetaRoute(path: string): boolean {
  return BETA_ROUTES.has(path);
}
